var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
export var StyledTable = styled.table(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  border-collapse: ", ";\n  position: ", ";\n"], ["\n  width: 100%;\n  height: 100%;\n  border-collapse: ", ";\n  position: ", ";\n"])), function (_a) {
    var hasStickyHeader = _a.hasStickyHeader;
    return (hasStickyHeader ? "separate" : "collapse");
}, function (_a) {
    var hasStickyHeader = _a.hasStickyHeader;
    return hasStickyHeader && "relative";
});
export var BlockLayout = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: ", ";\n  border-spacing: 0;\n"], ["\n  display: ", ";\n  border-spacing: 0;\n"])), function (_a) {
    var hideHeader = _a.hideHeader;
    return (hideHeader ? "block" : "inline-block");
});
var templateObject_1, templateObject_2;
